import { render, staticRenderFns } from "./weixin.vue?vue&type=template&id=4b68b3cb&scoped=true&"
import script from "./weixin.vue?vue&type=script&lang=js&"
export * from "./weixin.vue?vue&type=script&lang=js&"
import style0 from "./weixin.vue?vue&type=style&index=0&id=4b68b3cb&prod&scoped=true&lang=css&"
import style1 from "./weixin.vue?vue&type=style&index=1&id=4b68b3cb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b68b3cb",
  null
  
)

export default component.exports